module.exports = __webpack_public_path__ + "img/rxl.1c54591d.jpg";